module.exports = __webpack_public_path__ + "img/Failed.d3a461e5.svg";